// O ApiError guarda o envelope do manager em `body`; a mensagem dele diz o
// motivo ("senha VNC não configurada"), a do Error só diz "api 503 on …".
export function errorMessage(err: unknown): string {
  const body = (err as { body?: { message?: unknown } } | null)?.body;
  if (body && typeof body.message === 'string' && body.message) {
    return body.message;
  }
  return err instanceof Error ? err.message : String(err);
}
